import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bar-chart',
	templateUrl:'./BarChartPluginCompPage.html',
	styles: [],
	styleUrls:['./BarChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BarChartPluginCompPage
{
	mdContent_880 = `\`\`\`java
import com.jwebmp.plugins.chartjs.BarChart;
\`\`\``;
	mdContent_881 = `\`\`\`java
BarChart(BarData data)
\`\`\``;
	mdContent_882 = `\`\`\`java
BarDataset dataset = new BarDataset()
    .setLabel("Sales")
    .setData(65, 59, 80, 81, 56)
    .addBackgroundColors(Color.RED, Color.GREEN, Color.BLUE)
    .setBorderWidth(2);
BarData data = new BarData()
    .addLabels("Mon", "Tue", "Wed", "Thu", "Fri")
    .addDataset(dataset);
String json = new BarChart(data).toJson();
\`\`\``;
}
